import React, { useState, useEffect } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Platform,
  TextInput,
} from "react-native";

import { isWeb } from "../../../../helpers/utils";
import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import SendCommentIcon from "../../common/icons/reports/SendCommentIcon";

export default function CommentInput({
  selectedComment,
  saveMessage = () => {},
}) {
  const [text, setText] = useState("");

  useEffect(() => {
    if (selectedComment) {
      setText(selectedComment.message);
    }
  }, [selectedComment]);

  // ------------------------------------- METHODS -------------------------------------
  const onSave = () => {
    saveMessage({ ...selectedComment, message: text });
    setText("");
  };

  return (
    <View style={[appStyles.footerOptions, styles.root]}>
      <TextInput
        name={"commentEdit"}
        style={styles.input}
        placeholderTextColor={AppTheme.DEFAULT_COLOR}
        placeholder={"Start typing"}
        onChangeText={(t) => setText(t)}
        value={text || ""}
      />
      <TouchableOpacity style={styles.icon} onPress={onSave}>
        <SendCommentIcon />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    position: "relative",
    backgroundColor: "#8B92A1",
    paddingHorizontal: 8,
    paddingTop: 4,
    paddingBottom: isWeb ? 4 : 48,
    bottom: isWeb ? 8 : -24,
  },
  input: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: "#2D3142",
    width: "100%",
    height: 40,
    borderRadius: 4,
    backgroundColor: "#F3F2F1",
    borderColor: "#ABADB3",
    borderWidth: 0.5,
    paddingHorizontal: isWeb ? 10 : 20,
    paddingRight: 46,
  },
  icon: {
    position: "absolute",
    right: 16,
    top: 10,
    zIndex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
